import { render, staticRenderFns } from "./AuthComponent.vue?vue&type=template&id=58aa51dd&"
import script from "./AuthComponent.vue?vue&type=script&lang=js&"
export * from "./AuthComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports